import { render } from "./Darkmode.vue?vue&type=template&id=46d8783e"
import script from "./Darkmode.vue?vue&type=script&lang=js"
export * from "./Darkmode.vue?vue&type=script&lang=js"

import "./Darkmode.vue?vue&type=style&index=0&id=46d8783e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__